/* ================================================================
   USA PALM — HEATHERED POLO SIZE CHART PAGE
   Scroll reveal + inches/cm unit toggle
   ================================================================ */
(function () {
    'use strict';

    // ── Scroll reveal ──────────────────────────────────────────────
    const revealItems = document.querySelectorAll('.reveal');
    if (revealItems.length && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        revealItems.forEach((el) => observer.observe(el));
    } else {
        revealItems.forEach((el) => el.classList.add('is-visible'));
    }

    // ── Unit toggle (inches / cm) ──────────────────────────────────
    const chartWrap = document.querySelector('.chart-wrap');
    const unitBtns = document.querySelectorAll('.unit-btn');

    if (chartWrap && unitBtns.length) {
        chartWrap.dataset.units = 'in';

        unitBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const unit = btn.dataset.unit;
                chartWrap.dataset.units = unit;
                unitBtns.forEach((b) =>
                    b.classList.toggle('is-active', b === btn)
                );
            });
        });
    }
})();
